import React from "react"
import * as S from "./styled"
import OurImg from "../OurImg"
import AccordionBasics from "../AccordionBasics"
import AccordionAnalytics from "../AccordionAnalytics"
import AccordionTime from "../AccordionTime"
import AccordionWork from "../AccordionWork"
import AccordionCulture from "../AccordionCulture"
import AccordionFlex from "../AccordionFlex"
import AccordionPerformace from "../AccordionPerformace"
import AccordionHiring from "../AccordionHiring"
import AccordionFlexible from "../AccordionFlexible"
import { withTrans } from "../../i18n/withTrans"

/* import { AccordionData } from "../../utils/AccordionData" */

const Solutions = ({ t, i18n }) => (
  <S.WrapperTitleSolutions>
    {/*     <div className="container">
      <div className="column">
        <S.TitleSolutions>
          Our Solutions
        </S.TitleSolutions>
      </div >
    </div> */}
    <S.Wrapper>
      <div className="container">
        <div className="columns">
          <div className="column">
            <AccordionBasics />
            <AccordionAnalytics />
            <AccordionTime />
            <AccordionWork />
            <AccordionCulture />
            <AccordionFlex />
            {/*             <AccordionPerformace/>
            <AccordionHiring/>
            <AccordionFlexible/> */}
            {/*             <Accordion data={AccordionData} index={0}/>
            <Accordion data={AccordionData} index={1}/>
            <Accordion data={AccordionData} index={2}/>
            <Accordion data={AccordionData} index={3}/>
            <Accordion data={AccordionData} index={4}/>
            <Accordion data={AccordionData} index={5}/>
            <Accordion data={AccordionData} index={6}/> */}
          </div>
          {/*           <div className="column is-flex is-justify-content-flex-end is-align-items-center img-Our">
            <OurImg/>
          </div> */}
        </div>
      </div>
    </S.Wrapper>
  </S.WrapperTitleSolutions>
)

export default withTrans(Solutions)
